import {
  AUTH_STATUS_APPROVE,
  AUTH_STATUS_AR,
  AUTH_STATUS_NEW,
  AUTH_STATUS_PROGRESSING,
  AUTH_STATUS_REJECT,
  AUTH_STATUS_RR,
} from "constants/FormatDataContanst";

export const getStatus = t => {
  const AUTH_STATUS = {
    [AUTH_STATUS_NEW]: {
      //"Lưu tạm",
      text: "Lưu tạm",
      badgeColor: "badge-soft-primary",
    },
    [AUTH_STATUS_APPROVE]: {
      //"CQT đã duyệt yêu cầu",
      text: "CQT đã duyệt yêu cầu",
      badgeColor: "badge-soft-success",
    },
    [AUTH_STATUS_AR]: {
      // CQT đã tiếp nhận yêu cầu
      text: "CQT đã tiếp nhận yêu cầu",
      badgeColor: "badge-soft-info",
    },
    [AUTH_STATUS_REJECT]: {
      //"CQT từ chối duyệt yêu cầu",
      text: "CQT từ chối duyệt yêu cầu",
      badgeColor: "badge-soft-danger",
    },

    [AUTH_STATUS_RR]: {
      //"CQT từ chối tiếp nhận yêu cầu",
      text: "CQT từ chối tiếp nhận yêu cầu",
      badgeColor: "badge-soft-danger",
    },
    [AUTH_STATUS_PROGRESSING]: {
      //"Đã gửi duyệt"
      text: "Đã gửi duyệt",
      badgeColor: "badge-soft-warning",
    },
  };

  return {
    AUTH_STATUS: AUTH_STATUS,
  };
};
